import React, { createContext, useContext, useState, useCallback } from 'react';
import ErrorModal from '../components/ErrorModal';

const ErrorContext = createContext();

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
  const [errorType, setErrorType] = useState(null);
  const [customMessage, setCustomMessage] = useState(undefined);
  const [primaryAction, setPrimaryAction] = useState(null);
  const [cancelAction, setCancelAction] = useState(null);

  // cancel runs when the user presses Cancel, e.g. to leave a page that can't continue
  const showError = useCallback((type, message = undefined, action = null, cancel = null) => {
    setErrorType(type);
    setCustomMessage(message);
    setPrimaryAction(() => action);
    setCancelAction(() => cancel);
  }, []);

  const closeError = useCallback(() => {
    setErrorType(null);
    setCustomMessage(undefined);
    setPrimaryAction(null);
    setCancelAction(null);
  }, []);

  const handlePrimary = () => {
    if (primaryAction) {
      primaryAction();
    }
    else if (errorType === 'unexpected' || errorType === 'server') {
      window.location.reload();
      return;
    }

    closeError();
  };

  const handleCancel = () => {
    const cancel = cancelAction;
    closeError();
    if (cancel) cancel();
  };

  return (
    <ErrorContext.Provider value={{ showError, closeError }}>
      {children}
      <ErrorModal
        isOpen={!!errorType}
        type={errorType}
        customMessage={customMessage}
        onClose={handleCancel}
        onPrimaryAction={handlePrimary}
      />
    </ErrorContext.Provider>
  );
};
